<template>
  <div class="mt-4">
    <v-btn small color="secondary" dark class="mb-4 ml-4" @click="openCreateDialog">
      追加
    </v-btn>

    <v-data-table
      :headers="headers"
      :items="contentPages"
      hide-default-footer
      :items-per-page="-1"
    >
      <template #[`item.edit`]="{ item }">
        <v-btn icon @click.stop="openEditDialog(item)">
          <v-icon small dark>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <template #[`item.delete`]="{ item }">
        <v-btn icon @click.stop="openDeleteDialog(item)">
          <v-icon small dark>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="formDialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ isEditing ? '教科書ページ編集' : '教科書ページ追加' }}</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="editedPage.publisher_id"
                :items="publishers"
                item-text="name"
                item-value="id"
                label="出版社"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editedPage.start_page"
                label="開始ページ"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editedPage.end_page"
                label="終了ページ"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="formDialog = false">キャンセル</v-btn>
          <v-btn color="blue darken-1" text @click="savePage">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-confirm-dialog
      ref="deleteConfirm"
      title="教科書ページ削除"
      :message="deleteMessage"
      buttonMessage="削除"
      @confirm="confirmDelete"
    />
  </div>
</template>

<script>
import VConfirmDialog from '@/components/atoms/ConfirmDialog'

export default {
  components: { VConfirmDialog },
  props: {
    contentPages: { type: Array, default: () => [] },
    contentId: { type: Number, required: true },
  },
  data() {
    return {
      headers: [
        { text: '出版社', align: 'start', value: 'publisher_name' },
        { text: '開始ページ', align: 'center', value: 'start_page' },
        { text: '終了ページ', align: 'center', value: 'end_page' },
        { text: '編集', align: 'center', value: 'edit', sortable: false },
        { text: '削除', align: 'center', value: 'delete', sortable: false },
      ],
      formDialog: false,
      isEditing: false,
      editedPage: {
        id: null,
        publisher_id: null,
        start_page: 0,
        end_page: 0,
      },
      deletingPage: null,
      publishers: [],
    }
  },
  computed: {
    deleteMessage() {
      return this.deletingPage
        ? `${this.deletingPage.publisher_name} (${this.deletingPage.start_page}〜${this.deletingPage.end_page}) を削除します。よろしいですか。`
        : ''
    },
  },
  async mounted() {
    await this.loadPublishers()
  },
  methods: {
    async loadPublishers() {
      // Publishersは教科のsubjectsにネストされているため、subjectsから取得
      // もしallSubjectsに publishers があればそこから取得、なければ空
      const allSubjects = this.$store.state.master.allSubjects || []
      const publisherSet = new Map()
      allSubjects.forEach(s => {
        if (s.publishers) {
          s.publishers.forEach(p => {
            if (!publisherSet.has(p.id)) {
              publisherSet.set(p.id, p)
            }
          })
        }
      })
      this.publishers = Array.from(publisherSet.values())
    },
    openCreateDialog() {
      this.isEditing = false
      this.editedPage = { id: null, publisher_id: null, start_page: 0, end_page: 0 }
      this.formDialog = true
    },
    openEditDialog(page) {
      this.isEditing = true
      this.editedPage = { ...page }
      this.formDialog = true
    },
    async savePage() {
      const data = {
        content_page: {
          publisher_id: this.editedPage.publisher_id,
          start_page: parseInt(this.editedPage.start_page),
          end_page: parseInt(this.editedPage.end_page),
        }
      }

      try {
        if (this.isEditing) {
          await this.$axios.put(
            `/api/v1/admin/contents/${this.contentId}/content_pages/${this.editedPage.id}`,
            data
          )
        } else {
          await this.$axios.post(
            `/api/v1/admin/contents/${this.contentId}/content_pages`,
            data
          )
        }
        this.formDialog = false
        this.$toasted.global.success({ message: '教科書ページを保存しました' })
        this.$emit('updated')
      } catch (e) {
        this.$toasted.global.error({ message: '教科書ページの保存に失敗しました' })
      }
    },
    openDeleteDialog(page) {
      this.deletingPage = page
      this.$refs.deleteConfirm.open()
    },
    async confirmDelete() {
      if (!this.deletingPage) return
      try {
        await this.$axios.delete(
          `/api/v1/admin/contents/${this.contentId}/content_pages/${this.deletingPage.id}`
        )
        this.$toasted.global.success({ message: '教科書ページを削除しました' })
        this.$emit('updated')
      } catch (e) {
        this.$toasted.global.error({ message: '教科書ページの削除に失敗しました' })
      }
      this.deletingPage = null
    },
  },
}
</script>

<style lang="stylus" scoped>
</style>
